import React from 'react';
import { ErrorBoundary, InfoCard } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { SonarQubeMetricsContainer } from './SonarQubeMetricsContainer';

/** @public */
export const ComponentScoreCard = () => {
  const { entity } = useEntity();

  return (
    <ErrorBoundary>
      <InfoCard title="Score Card">
        <SonarQubeMetricsContainer entity={entity} />
      </InfoCard>
    </ErrorBoundary>
  );
};
